import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Box
} from '@mui/material';
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
    root: {},
    title: {
        fontSize: '24px',
        fontStyle: 'Roboto-Regular',
        textAlign: 'center',
        color: '#981B49',
        marginBottom: '20px',
    },
}));

const CustomTable = ({ legendData, headerOne }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box sx={{ margin: 4 }}>
            <div className={classes.title}>
                {legendData.title}
            </div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>{headerOne}</strong></TableCell>
                            <TableCell><strong>Nr</strong></TableCell>
                            <TableCell><strong>{t('LOCAL_INDICATORS.MUNICIPALITIES')}</strong></TableCell>
                            <TableCell><strong>{t('LOCAL_INDICATORS.COLORS')}</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {legendData.data.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell
                                    sx={{
                                        width: '200px',
                                    }}
                                >
                                    {row.population ? row.population : row.label}
                                </TableCell>
                                <TableCell>{row.count}</TableCell>
                                <TableCell>{row.entities}</TableCell>
                                <TableCell>
                                    <Box
                                        sx={{
                                            width: 30,
                                            height: 30,
                                            backgroundColor: row.color,
                                            borderRadius: '4px',
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default CustomTable;
